import React, { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { useApi } from "../helpers/useApi";
import { useNavigate } from "react-router-dom";
import { API_URL_ENDPOINT } from "../appsetting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import { confirmRequestToast, sendError, sendSuccess } from "../helpers/Helper";

export const LinkBilty = ({ loadid, onBiltyGenerate, onBiltyAssigned }) => {
  const callApi = useApi();
  const navigate = useNavigate();
  const [selectedBilty, setSelectedBilty] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    if (searchTerm == "") {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
      return;
    }
    const delay = setTimeout(() => {
      if (isTyping) {
        setSelectedBilty(0);
        setIsTyping(false);
        getData(1);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Bilty + `?${queryParams}`
      );
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  };

  const assignBilty = async () => {
    try {
      setSubmitting(true);
      const response = await callApi(
        API_URL_ENDPOINT.Load + `/assign-bilty/${loadid}/${selectedBilty}`
      );
      if (response.status) {
        sendSuccess(response.message)
        onBiltyAssigned();
      }else{
        throw new Error(response.message || "Something Went Wrong")
      }
    } catch(ex) {
      sendError(ex.message)
    } finally {
      setSubmitting(false);
    }
  };

  const selectBilty = (id) => {
    if (selectedBilty == id) {
      setSelectedBilty(0);
    } else {
      setSelectedBilty(id);
    }
  };

  return (
    <div className="p-2">
      <div className="d-flex align-items-center mb-4">
        <Form.Control
          placeholder="Search Bilty..."
          className="shadow-none "
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsTyping(true);
          }}
        />
        <Button
          variant="primary"
          className="ms-2 text-nowrap"
          onClick={() => onBiltyGenerate()}
        >
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Generate New Bilty
        </Button>
      </div>

      {dataLoading ? (
        <div className="text-center my-3">
          <span className="spinner-border text-primary" role="status"></span>
        </div>
      ) : (
        // Only show table if data exists and searchTerm is not empty
        data?.items?.length > 0 &&
        searchTerm && (
          <>
            {/* {selectedBilty != 0 && ( */}
            <button
              className="btn btn-success btn-sm mb-3"
              disabled={selectedBilty == 0 || submitting}
              onClick={() =>
                confirmRequestToast(
                  () => assignBilty(),
                  "Confirm Assign",
                  "Are you sure you want to assign this Transporter? Once Assigned, it can't be changed.",
                  "Confirm"
                )
              }
            >
              <FontAwesomeIcon className="me-1" icon={faCheckCircle} /> Assign
              Bilty
            </button>
            {/* )} */}
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Bilty Number</th>
                  <th className="border-0 text-center">Date</th>
                  <th className="border-0 text-center">Vehicle Number</th>
                  <th className="border-0 text-center">From</th>
                  <th className="border-0 text-center">To</th>
                  <th className="border-0 text-center">Consignor</th>
                  <th className="border-0 text-center">Consignee</th>
                  <th className="border-0 text-center">Total Amount</th>
                  <th className="border-0 text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center align-middle">
                      <input
                        type="checkbox"
                        onChange={() => selectBilty(item.id)}
                        checked={selectedBilty === item.id}
                        className="form-check-input shadow-none me-2 mt-0"
                      />
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.biltyNumber || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.createdAt || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.vehicleNumber || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.consignorAddress || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.consigneeAddress || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.consignorName || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.consigneeName || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.basicFreight || "-"}
                    </td>
                    <td className="fw-bold align-middle text-center">-</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )
      )}
    </div>
  );
};
